//updated implement script T3.

//HELPER
        function waitForElement(selector, callback) {
          const element = document.querySelector(selector);
          if (element) {
            callback(element);
          } else {
            setTimeout(() => waitForElement(selector, callback), 100); // Retry after 100ms
          } 
        }


// ver. 00
 
waitForElement('.kaching-bundles__selling-plan-select option:last-child', (element) => {

//1 - Remove "Delivery every" in each sell plan
  document.querySelectorAll(
    '.kaching-bundles__selling-plan-select option'
  ).forEach(option => {
    option.textContent = option.textContent.replace('Deliver every', '');
  });

  const subHeaderEl = document.querySelector(
    '.kaching-bundles__subscriptions__card .kaching-bundles__bar-first-line .kaching-bundles__subscriptions__title'
  );

  const subBottomHeaderEl = document.querySelector(
    '.kaching-bundles__subscriptions__card .kaching-bundles__subscriptions__subtitle'
  );

  const select = document.querySelector('.kaching-bundles__selling-plan-select');

//2 Update "x % OFF" text when user changes the selection
  if (select) {
    select.addEventListener('change', () => {
      const selectedIndex = select.selectedIndex;
      const selectedOption = select.options[selectedIndex];
      if (selectedIndex === 0) {
          subHeaderEl.textContent = 'Subscribe & Save 17%';
      } else if (selectedIndex === 1) {
          subHeaderEl.textContent = 'Subscribe & Save 15%';
      }
      console.log("Selected option value:", selectedOption.value);
      console.log("Selected option text:", selectedOption.text);

      //make sure the selling plan text updated as well.
      
    });
  }

});


/* new ver 01. wip */
